// extracted by mini-css-extract-plugin
export default {"accounts_list":"virtualNumbers_accounts_list__+TlTN","loader_wrapper":"virtualNumbers_loader_wrapper__T0tqR","centeredWrapper":"virtualNumbers_centeredWrapper__oGSv2"};